import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { authApi } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authApi
      .status()
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const csrfRes = await authApi.csrf();
    localStorage.setItem('csrfToken', csrfRes.data.csrfToken);
    const res = await authApi.login(username, password);
    localStorage.setItem('csrfToken', res.data.csrfToken);
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    await authApi.logout();
    localStorage.removeItem('csrfToken');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => useContext(AuthContext);
